
import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    let storeLang = localStorage.getItem("lang");
    if ("zh" === storeLang) {
      return "zh";
    } else {
      return "en";
    }
  });

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
  };

  return (
    <LanguageContext.Provider value={{ selectedLanguage, handleLanguageSelect }}>
      {children}
    </LanguageContext.Provider>
  );
};
